<div>
    <div class="modal-header"  style="padding: 0px;">
        <div class="modal-title" id="exampleModalLabel">
          <mat-form-field  style="margin-right: auto;" fxFlex="40%">
            <input matInput type="text" placeholder="Search">
          </mat-form-field>
        </div>
        <button
          type="button" mat-button
          (click)="close()" style="background-color: transparent;
          background-repeat: no-repeat;
          border: none;
          color: red;
          cursor: pointer;
          overflow: hidden;
          outline: none;"
        > <i class="fa fa-times"></i></button>
        
      </div>
      <div class="row col-md-12" style="margin-top: 1%">
        <div class="col-md-12">
          <div>
            <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" matSort
              class="example-container mat-elevation-z8"  style="text-align: center;display: flex;width: 100%;">
    
             <!-- <ng-container matColumnDef="No">
                <th mat-header-cell *matHeaderCellDef
                  style="text-align: center;font-weight: bold;background-color:wheat;"> No&nbsp;&nbsp;</th>
                <td mat-cell *matCellDef="let element"> {{element.No}} </td>
              </ng-container>-->
              <ng-container matColumnDef="TransformerID">
                <th mat-header-cell *matHeaderCellDef
                  style="text-align: center;cursor: pointer;font-weight: bold;background-color: wheat;"> TransformerID&nbsp;&nbsp;</th>
                <td mat-cell *matCellDef="let element"style="cursor: pointer;" >
                  {{element.TransformerID}} </td>
              </ng-container>
              <ng-container matColumnDef="SiteName">
                <th mat-header-cell *matHeaderCellDef
                  style="text-align: center;font-weight: bold;background-color: wheat;"> SiteName&nbsp;&nbsp;</th>
                <td mat-cell *matCellDef="let element"> {{element.SiteName}} </td>
              </ng-container>
              <!--<ng-container matColumnDef="LoadDetails">
                <th mat-header-cell *matHeaderCellDef
                  style="text-align: center;font-weight: bold;background-color: wheat;"> LoadDetails&nbsp;&nbsp;</th>
                <td mat-cell *matCellDef="let element"> {{element.LoadDetails}} </td>
              </ng-container>-->
              <ng-container matColumnDef="PumpID">
                <th mat-header-cell *matHeaderCellDef
                  style="text-align: center;font-weight: bold;background-color:wheat;"> Pump ID&nbsp;&nbsp;</th>
                <td mat-cell *matCellDef="let element"> {{element.PumpID}} </td>
              </ng-container>
              <ng-container matColumnDef="Communication">
                <th mat-header-cell *matHeaderCellDef
                  style="text-align: center;font-weight: bold;background-color: wheat;"> Communication&nbsp;&nbsp;</th>
                <td mat-cell *matCellDef="let element"  ><div [ngClass] ="{'dot':element.Communication == 1,'blackdot':element.Communication == 0}"></div>  </td>
              </ng-container>
              <!-- <ng-container matColumnDef="Voltage">
                <th mat-header-cell *matHeaderCellDef
                  style="text-align: center;font-weight: bold;background-color: wheat;"> Voltage&nbsp;&nbsp;</th>
                <td mat-cell *matCellDef="let element" style="font-size:x-small;"> <b style="color: red;">Rphase:
                    {{element.Voltage.RPhase}}</b><br> <b style="color: rgb(136, 136, 7);"> YPhase:
                    {{element.Voltage.YPhase}}</b><br><b style="color: blue;">Bphase: {{element.Voltage.BPhase}}</b> </td>
              </ng-container>
              <ng-container matColumnDef="Current">
                <th mat-header-cell *matHeaderCellDef
                  style="text-align: center;font-weight: bold;background-color: wheat;"> Current&nbsp;&nbsp; </th>
                <td mat-cell *matCellDef="let element" style="font-size:x-small;"> <b style="color: red;">Rphase:
                    {{element.Current.RPhase}}</b><br> <b style="color: rgb(136, 136, 7);"> YPhase:
                    {{element.Current.YPhase}}</b><br><b style="color: blue;">Bphase: {{element.Current.BPhase}}</b> </td>
              </ng-container> 
              <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: bold;background-color: wheat;"> Status&nbsp;&nbsp;</th>
                <td mat-cell   *matCellDef="let element" ><img [matTooltip]="alertsData" matTooltipPosition="above"  matTooltipClass="auto-adjust-tooltip" [src]="element.Status" /> </td>
              </ng-container>-->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[7, 15, 20]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
    